import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const LizeraStoreDetailsComponent = () => {
  const { storeId } = useParams<{ storeId: string }>(); // Extracts "12" from the URL

    const baseURL = "/LizeraStoreDetails/StoreId"; // Base URL for the store details

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-12">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="CMS_Store_Details" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="Home" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="CMS_Store_Details" />
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="quick-links-bar mt-3">
        <div className="d-flex justify-content-between align-items-center">
        </div>
        <p className="mt-2 text-muted">Store ID from URL: {storeId}</p>
        <p>{baseURL}</p>
      </div>
    </>
  );
};

export default LizeraStoreDetailsComponent;
